import { subDays } from "date-fns";
import { nodes } from "Constants/filters";

/********** ACTION_TYPES **********/
export const actionTypes = {
  updateDowntimeFilter: "downtimeFilter/UPDATE",
};

/********** REDUCER **********/
export const initialState = {
  [nodes.downtimeList]: {
    isCurrentlyDown: true,
    dateFrom: subDays(new Date(), 6),
    dateTo: new Date(),
    startTime: "00:00:00",
    endTime: "23:59:59",
    pageSize: 10,
    pageOffset: 0,
    filters: {}
  },
};

const getUpadtedState = (state, action, selectedNode) => {
  const updatedObj = {
    ...state[selectedNode],
    ...action.payload,
  };
  delete updatedObj.infiniteLoading;
  delete updatedObj.noNetworkCall;
  return {
    ...state,
    [selectedNode]: updatedObj,
  };
};


export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.updateDowntimeFilter: {
      return getUpadtedState(state, action, nodes.downtimeList);
    }
    default: {
      return state;
    }
  }
};

/********** SELECTORS **********/
export const selectors = {
  getFilters: (state, node) => {
    if (node) return state.filters[node] || {};
    else return state.filters;
  },
  getDateFilter: (state, node) => {
    return {
      dateFrom: state.filters[node].dateFrom,
      dateTo: state.filters[node].dateTo,
    };
  },
};

/********** ACTION_CREATORS **********/
export const actions = {
  updateDowntimeFilter: (data) => ({
    type: actionTypes.updateDowntimeFilter,
    payload: data,
  }),
};
